import { Link } from 'react-router-dom';

const courses = [
  {
    title: "Bronze Medallion Recertification",
    description: "Refresh your skills and maintain your Bronze Medallion credentials.",
    path: "/programs/lifeguard-classes#bronze-medallion"
  },
  {
    title: "Bronze Cross Recertification",
    description: "Renew your Bronze Cross with updated techniques and fitness assessments.",
    path: "/programs/lifeguard-classes#bronze-cross"
  },
  {
    title: "National Lifeguard Recertification",
    description: "Stay current with the latest standards and requalify as an NLS-certified lifeguard.",
    path: "/programs/lifeguard-classes#national-lifeguard"
  },
  {
    title: "Standard First Aid Recertification",
    description: "Complete the required update for SFA certification to remain valid.",
    path: "/programs/lifeguard-classes#standard-first-aid"
  }
];

const Recertifications = () => (
  <div className="bg-white py-24 px-6 text-gray-900">
    <div className="max-w-5xl mx-auto">
      <h1 className="text-4xl font-bold text-blue-800 text-center mb-12">
        Recertification Courses
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {courses.map((course, idx) => (
          <div key={idx} className="bg-blue-50 p-6 rounded-xl shadow hover:shadow-md transition">
            <h3 className="text-2xl font-semibold text-blue-900 mb-2">{course.title}</h3>
            <p className="text-sm text-gray-700 mb-4">{course.description}</p>
            <Link to={course.path}>
              <button className="bg-blue-700 text-white px-4 py-2 text-sm rounded-md hover:bg-blue-800 transition">
                See Schedule
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Recertifications;
